/**
 * Fire-and-forget recording of usage events for Admin Usage & growth metrics.
 * Used when user clicks "Read Article" or follows an external link.
 */
import type { SupabaseClient } from '@supabase/supabase-js'

export async function recordArticleRead(
  supabase: SupabaseClient,
  articleId: string,
  userId: string | null
): Promise<void> {
  try {
    await supabase.from('article_read_events').insert({
      article_id: articleId,
      user_id: userId,
    })
  } catch {
    // Fire-and-forget; do not block UI or surface errors
  }
}

export async function recordLinkFollow(
  supabase: SupabaseClient,
  linkId: string,
  userId: string | null
): Promise<void> {
  try {
    await supabase.from('link_follow_events').insert({
      link_id: linkId,
      user_id: userId,
    })
  } catch {
    // Fire-and-forget; do not block UI or surface errors
  }
}
